import { wordPressRequest } from "./wordpress/ajax";

var pagenum = 2;

// Load More Button

document.getElementById("newsLoadMore").onclick = () => {
	const url = phpVals.adminAjax;

	// Setup formdata
	let data = new FormData();
	data.append("action", "bt_news_filter");
	data.append("nonce", phpVals.btNonce);
	data.append("paged", pagenum);

	const params = new URLSearchParams(data);

	wordPressRequest("POST", url, params)
		.then((data) => {
			document.getElementById("newsList").insertAdjacentHTML("beforeend", data.content);

			if (pagenum > data.max) {
				document.getElementById("newsLoadMore").classList.add("!hidden");
			} else {
				document.getElementById("newsLoadMore").classList.remove("!hidden");
			}
		})
		.catch((error) => {
			console.error(error);
		});

	pagenum++;
};
